import 'shared/application'

$(document).ready(() => {
  $('#flash-message.from-html').on('click', () => {
    $(this).hide()
  })

  $('#flash-message.from-html').delay(4000).fadeOut()

  if ($('.modal.show-on-load').length > 0) {
    $('.show-on-load').modal('show')
  }
})

// some zendesk config
window.zESettings = {
  webWidget: {
    zIndex: 300,
    contactForm: { ticketForms: [{ id: 5486073315740 }] },
  },
}
